export default "__VITE_ASSET__FSha9nJn__"